import React, { useEffect, useRef, useState } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import axios from "axios";
import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Icon,
  Row,
  Col,
  Input,
  Checkbox,
  message,
  Space,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import moment from "moment";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import numberFormat from "../../utils/numberFormat";
import { authenticateAdmin } from "../../utils/authentications";
import SelectFieldGroup from "../../commons/SelectFieldGroup";

import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import { category_type_options } from "../../utils/Options";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import {
  onCondimentsSearch,
  addKeysToArray,
  onBranchSearch,
  onWarehouseSearch,
  onMainCategorySearch,
} from "../../utils/utilities";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";

const { Content } = Layout;

const url = "/api/categories/";
const title = "Category Form";

const initialValues = {
  _id: null,
  name: "",
  condiments: [],
  not_in_menu: false,
  is_for_walkin_only: false,
  is_promo_items: false,
  category_type: null,
  sequence: "",
};

const initialItemValues = {
  stock: null,
};

const date_fields = [];
export default function CategoryForm({ history }) {
  const [errors, setErrors] = useState({});
  const [search_state, setSearchState] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);

  const [state, setState] = useState(initialValues);
  const [item, setItem] = useState(initialItemValues);

  const condimentField = useRef(null);
  const addItemButton = useRef(null);
  const [options, setOptions] = useState({
    condiments: [],
  });

  const items_column = [
    {
      title: "Item",
      dataIndex: ["name"],
    },

    {
      title: "Sequence",
      dataIndex: ["sequence"],
      render: (value, record, index) => (
        <Input
          className="table-input-sequence"
          value={value}
          onChange={(e) => {
            const value = e.target.value;
            const condiments = [...state.condiments];
            condiments[index] = {
              ...condiments[index],
              sequence: value,
            };
            onChange({
              key: "condiments",
              value: condiments,
              setState,
            });
          }}
        />
      ),
    },

    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) && isEmpty(state.deleted) && (
            <span
              onClick={() =>
                onDeleteItem({
                  field: "condiments",
                  index,
                  setState,
                })
              }
            >
              <i className="fas fa-trash-alt"></i>
            </span>
          )}
        </span>
      ),
    },
  ];

  const records_column = [
    {
      title: "Main Category",
      dataIndex: ["main_category"],
      width: 120,
      render: (main_category, record) => (
        <SelectFieldGroup
          defaultValue={main_category?.name}
          onSearch={(value) =>
            onMainCategorySearch({ value, options, setOptions })
          }
          onChange={(index) => {
            const main_category = options.main_categories?.[index] || null;

            axios
              .post(`/api/categories/${record._id}/main-category`, {
                main_category,
              })
              .then(() => {
                return message.success("Category updated");
              })
              .catch((err) => {
                return message.error(
                  "There was an error processing your request"
                );
              });
          }}
          error={errors.main_category}
          data={options.main_categories}
          column="name"
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
    },

    // {
    //   title: "Type",
    //   dataIndex: "category_type",
    //   width: 120,
    //   render: (category_type, record) => (
    //     <SimpleSelectFieldGroup
    //       defaultValue={category_type}
    //       onChange={(category_type) => {
    //         axios
    //           .post(`/api/categories/${record._id}/category-type`, {
    //             category_type,
    //           })
    //           .then(() => {
    //             return message.success("Type updated");
    //           })
    //           .catch((err) => {
    //             return message.error(
    //               "There was an error processing your request"
    //             );
    //           });
    //       }}
    //       error={errors.category_type}
    //       options={options.category_types || []}
    //     />
    //   ),
    // },
    {
      title: "For Walkin Only",
      dataIndex: "is_for_walkin_only",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },
    {
      title: "Has No Discount",
      dataIndex: "has_no_discount",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },
    {
      title: "Promo Items",
      dataIndex: "is_promo_items",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },

    {
      title: "Seq",
      dataIndex: "sequence",
      align: "center",
      width: 100,
      render: (value, record) => (
        <Input
          defaultValue={value}
          className="table-input-sequence"
          onBlur={(e) => {
            axios
              .post(`/api/categories/${record._id}/sequence`, {
                sequence: e.target.value,
              })
              .catch((err) => console.log(err));
          }}
        />
      ),
    },
    {
      title: "Not in Menu",
      dataIndex: "not_in_menu",
      align: "center",
      width: 50,
      render: (not_in_menu, record, index) => (
        <Checkbox
          defaultChecked={not_in_menu}
          onChange={(e) => {
            const checked = e.target.checked;

            axios
              .post(`/api/categories/${record._id}/not-in-menu`, {
                not_in_menu: checked,
              })
              .then(() => {
                message.success("Item updated");
              })
              .catch((err) => {
                message.error("There was a problem processing your request");
              });
          }}
        />
      ),
    },
    {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <span
          onClick={() =>
            edit({
              record,
              setErrors,
              setRecords,
              url,
              setState,
            })
          }
        >
          <i className="fas fa-edit"></i>
        </span>
      ),
    },
  ];

  // useEffect(() => {
  //   axios.get("/api/category-types").then((response) => {
  //     setOptions((prevState) => ({
  //       ...prevState,
  //       category_types: response.data.map((o) => o.name),
  //     }));
  //   });

  //   return () => {};
  // }, []);

  useEffect(() => {
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <Row justify="space-between" align="middle">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <Row justify="end">
            <Space>
              <div style={{ width: "400px", margin: "16px 0px" }}>
                <SelectFieldGroup
                  label="Main Category"
                  name="name"
                  value={search_state.main_category?.name}
                  onChange={(index) => {
                    setSearchState((prevState) => {
                      return {
                        ...prevState,
                        main_category: options.main_categories?.[index] || null,
                      };
                    });
                  }}
                  onSearch={(value) =>
                    onMainCategorySearch({ value, setOptions })
                  }
                  formItemLayout={smallFormItemLayout}
                  data={options?.main_categories}
                />
              </div>

              <Searchbar
                name="search_keyword"
                onSearch={(value, e) => {
                  e.preventDefault();
                  onSearch({
                    page: 1,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: {
                      ...search_state,
                    },
                  });
                }}
                onChange={(e) => setSearchKeyword(e.target.value)}
                value={search_keyword}
                onNew={() => {
                  setRecords([]);
                  setState(initialValues);
                }}
              />
            </Space>
          </Row>
        </div>
      </Row>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                  condiments: state.condiments.sort(
                    (a, b) => a.sequence - b.sequence
                  ),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
              });
            }}
            initialValues={initialValues}
          >
            <SelectFieldGroup
              label="Main Category"
              value={state.main_category?.name}
              onSearch={(value) =>
                onMainCategorySearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const main_category = options.main_categories?.[index] || null;
                setState((prevState) => ({
                  ...prevState,
                  main_category,
                }));
              }}
              error={errors.main_category}
              formItemLayout={formItemLayout}
              data={options.main_categories}
              column="name"
            />

            <TextFieldGroup
              label="Name"
              name="name"
              error={errors.name}
              formItemLayout={formItemLayout}
              value={state.name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <TextFieldGroup
              label="Sequence"
              name="sequence"
              error={errors.sequence}
              formItemLayout={formItemLayout}
              value={state.sequence}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            {/* <SimpleSelectFieldGroup
              label="Category Type"
              name="category_type"
              value={state.category_type}
              onChange={(value) => {
                onChange({
                  key: "category_type",
                  value: value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
              error={errors.payment_type}
              options={options.category_types ?? []}
            /> */}

            <CheckboxFieldGroup
              label="Not in Menu"
              name="not_in_menu"
              error={errors.not_in_menu}
              formItemLayout={formItemLayout}
              checked={state.not_in_menu}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            <CheckboxFieldGroup
              label="Walkin Only"
              name="is_for_walkin_only"
              error={errors.is_for_walkin_only}
              formItemLayout={formItemLayout}
              checked={state.is_for_walkin_only}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            <CheckboxFieldGroup
              label="Has No Discount"
              name="has_no_discount"
              error={errors.has_no_discount}
              formItemLayout={formItemLayout}
              checked={state.has_no_discount}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            <CheckboxFieldGroup
              label="Promo Items"
              name="is_promo_items"
              error={errors.is_promo_items}
              formItemLayout={formItemLayout}
              checked={state.is_promo_items}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            <SelectTagFieldGroup
              label="Assigned Branches"
              value={state.assigned_branches}
              onSearch={(value) => {
                onWarehouseSearch({ value, setOptions });
              }}
              onChange={(value) => {
                onChange({
                  key: "assigned_branches",
                  value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
              options={(options.warehouses || []).map((o) => {
                return {
                  label: o.name,
                  value: o.name,
                };
              })}
              help="Leave blank to assign to all branches"
            />

            {isEmpty(state.status) &&
              isEmpty(state.deleted) && [
                <Divider orientation="left" key="divider">
                  Condiments
                </Divider>,
                <Row key="form" className="ant-form-vertical" gutter={4}>
                  <Col span={12}>
                    <SelectFieldGroup
                      key="1"
                      inputRef={condimentField}
                      label="Item"
                      value={item.condiment?.name}
                      onSearch={(value) =>
                        onCondimentsSearch({ value, options, setOptions })
                      }
                      onChange={(index) => {
                        setItem({
                          ...item,
                          condiment: options.condiments[index],
                        });
                        //addItemButton.current.click();
                      }}
                      error={errors.condiment?.name}
                      formItemLayout={null}
                      data={options.condiments}
                      column="name"
                    />
                  </Col>

                  <Col
                    span={2}
                    className="is-flex align-items-center add-button-height"
                  >
                    <input
                      type="button"
                      ref={addItemButton}
                      className="button is-primary is-small"
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          condiments: [
                            ...prevState.condiments,
                            {
                              ...item.condiment,
                            },
                          ],
                        }));
                        setItem(initialItemValues);
                        condimentField.current.focus();
                      }}
                      value="Add"
                    />
                  </Col>
                </Row>,
              ]}

            <Table
              dataSource={addKeysToArray(state.condiments || [])}
              columns={items_column}
              pagination={false}
            />

            <Form.Item {...formItemLayout}>
              <div className="field is-grouped m-t-1">
                <div className="control">
                  <button className="button is-small is-primary">Save</button>
                </div>
                {!isEmpty(state._id) ? (
                  <span
                    className="button is-danger is-outlined is-small"
                    onClick={() => {
                      onDelete({
                        id: state._id,
                        url,
                        user: auth.user,
                      });
                      setState(initialValues);
                    }}
                  >
                    <span>Delete</span>
                    <span>
                      <i className="fas fa-times"></i>
                    </span>
                  </span>
                ) : null}
              </div>
            </Form.Item>
          </Form>
        ) : (
          <div className="products-table">
            <Table
              dataSource={records}
              columns={records_column}
              rowKey={(record) => record._id}
              pagination={false}
            />
          </div>
        )}
      </div>
    </Content>
  );
}
